/** Classic Greek prefectures (νομοί), genitive, without the «Νομός» prefix. */
export const GREEK_PREFECTURES = [
  'Αιτωλοακαρνανίας',
  'Αργολίδας',
  'Αρκαδίας',
  'Άρτας',
  'Αττικής',
  'Αχαΐας',
  'Βοιωτίας',
  'Γρεβενών',
  'Δράμας',
  'Δωδεκανήσου',
  'Έβρου',
  'Εύβοιας',
  'Ευρυτανίας',
  'Ζακύνθου',
  'Ηλείας',
  'Ημαθίας',
  'Ηρακλείου',
  'Θεσπρωτίας',
  'Θεσσαλονίκης',
  'Ιωαννίνων',
  'Καβάλας',
  'Καρδίτσας',
  'Καστοριάς',
  'Κέρκυρας',
  'Κεφαλληνίας',
  'Κιλκίς',
  'Κοζάνης',
  'Κορινθίας',
  'Κυκλάδων',
  'Λακωνίας',
  'Λάρισας',
  'Λασιθίου',
  'Λέσβου',
  'Λευκάδας',
  'Μαγνησίας',
  'Μεσσηνίας',
  'Ξάνθης',
  'Πέλλας',
  'Πιερίας',
  'Πρέβεζας',
  'Ρεθύμνου',
  'Ροδόπης',
  'Σάμου',
  'Σερρών',
  'Τρικάλων',
  'Φθιώτιδας',
  'Φλώρινας',
  'Φωκίδας',
  'Χαλκιδικής',
  'Χανίων',
  'Χίου',
] as const;
